import { HierarchyItem } from '@app/entities/models/personal-data/hierarchyItem.model';

export class PersonalDataAddress {
  id!: string;
  principal!: boolean;
  streetName!: string;
  streetNumber!: string;
  floorNumber!: string;
  stairway!: string;
  doorNumber!: string;
  streetTypeId!: string;
  streetTypeName!: string;
  countryIsoNumericCode!: string;
  countryName?: string;
  postalCode!: string;
  hierarchyCode?: string;
  hierarchy!: HierarchyItem[];
  province?: HierarchyItem;
  city?: HierarchyItem;
}
